/************************************
MODULE:         Popup
WHAT IT DOES:   All the functionality related to popup (quote popup)
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
    var isInited = false,
        globHref = null,
        isOpened = false,
        isAnimating = false,
        className = 'popup-opened',
        popupContainer,
        popupInner,
        popupContent,
        popupLoader,
        popupCloseDialog,
        popupCloseDialogInner,
        isCloseDialogFilled = false,
        isCloseDialogOpened = false,
        main,
        topParts,
        bottomParts,
        scrollToTop = 0,
        dimensions = {width: 0, height: 0},
        currentCustomClass = '',
        customClass = '',
        tween = null,
        tweenLoading = null,
        tweenClosingDialog = null,
        tweenLoadingCallback = new Array(),
        hash = '',
        historyApi = require('app.history'),
        trackingData = {},
        Handlebars = require('handlebars'),
        gaTracking = require('app.gatracking');


    function init() {
        if (isInited)
            return;

        isInited = true;

        window.onpageshow = function (event) {
            if (typeof event.persisted != 'undefined' && event.persisted) {
                hash = '';
                hashChange();
            }
        };

        popupContainer = $('.js-popup-container');
        popupInner = popupContainer.children().first();
        popupContent = popupContainer.find('.js-popup-content');
        popupLoader = popupContainer.find('.js-popup-loader');
        popupCloseDialog = popupContainer.find('.js-popup-close-dialog');
        popupCloseDialogInner = popupContainer.find('.js-popup-close-dialog-inner');        
        form = popupContainer.find('.js-custom-form');
         

        main = $('.js-main');
        var contentChildren = $('.js-content').children();
        topParts = $('.js-page-header').add(contentChildren.filter('.box_blue, .box_darkblue'));
        bottomParts = $('.js-page-footer').add(contentChildren.not('.box_blue, .box_darkblue'));

        initialHistory();

        if (!popupContainer.length || !popupContent.length || !popupLoader.length || !main.length) return;

        initLinks();
        popupCloseDialog.on('click', popupCloseDialogClick);
        popupContainer.on('popup:error', errorAlert);
        $(window).on('popup:reinit', reinitLinks);
        $(window).on('resize orientationchange', resetResize);
        $(window).on('resize:finished', resize);
        $(window).on('beforesubmit', beforeSubmit);

        window.onhashchange = hashChange;
        hashChange();
    }

    function initLinks() {
        $('.js-popup-btn').on('click.custompopup', clickProcess);
        $('.js-popup-close').on('click.custompopup', onClose);
        $('.js-popup-cancel').on('click.custompopup', closeCloseDialog);
        $('.js-popup-btn-load').on('click.custompopup', noDetailsSubmit);
    }

    function reinitLinks() {
        $('.js-popup-btn, .js-popup-close, .js-popup-cancel').off('click.custompopup');
        initLinks();
        $(window).trigger('sizeconvertlinks:reinit');
    }

    function resize() {
        if (isCloseDialogOpened) {
            popupContainer.css('max-height', Math.max(window.App.globals.height, popupCloseDialogInner.outerHeight(true)));
        }
        if (isOpened) {
            popupInner.css('min-height', window.App.globals.height);
        }
    }

    function resetResize() {
        main.css('max-width', '');
        popupContainer.css('max-width', '');
        //check if we just have a minimal-ui change event here
        if (window.App.globals.isMobile && dimensions.width == window.App.globals.width)
            return;
        scrollToTop = 0;
    }

    // hash change:
    // quote (0) -> 1 -> 2 -> 3 -> result (0)

    function getWindowHash() {
        return window.location.hash.substr(1) || "";
    }

    function getWindowHashDecoded() {
        return decodeURIComponent(getWindowHash());
    }

    function getHistoryArray() {
        return historyApi.getJsonFromSessionStorage("goback");
    }

    function setHistoryArray(back) {
        while(back.length > 100) {
            back = back.slice(10);
        }
        historyApi.setJsonToSessionStorage("goback", back);
    }

    function hashChange() {
        if (!popupContainer.length || !popupContent.length || !popupLoader.length || !main.length) return;

        var isWindowHashEmpty = !getWindowHashDecoded().length;

        //no hash indicates popup should be closed
        if (isOpened && isWindowHashEmpty) {
            close();
            //need to remove last enry from our sequence
            if (historyApi.isSessionAndHistory) {
                var back = getHistoryArray();
                back.pop();
                setHistoryArray(back);
            }
        }

        //not empty hash different to one stored in 'hash' variable indicate link clicking
        if (!isWindowHashEmpty && ('#' + hash) != window.location.hash) {

            //2 because first symbol is # and is indicates popup opening
            var href = getWindowHashDecoded().substr(1);
            if (href.indexOf('enquiryprocess') == -1) {
                return;
            }
            var params = historyApi.getAllQueryParametrs(href, params);

            if(!href.length) {
                return;
            }

            if (historyApi.isSessionAndHistory) {
                //go back store sequence of all steps
                var back = getHistoryArray(),
                    hashStep = back.pop(),
                    hashStepPrev = back.pop(),
                    counter = 0;

                while (hashStepPrev != undefined && (hashStepPrev >= hashStep && hashStepPrev != 0)) {
                    counter++;
                    hashStepPrev = back.pop();
                }

                setHistoryArray(back);

                if (counter) {
                    historyApi.goByHistory(-counter);
                    return;
                }
            }

            //let's create a virtucal link and click
            var link = makeLinkWithParams(href, params);

            if(params['siteid'] || params['step'])
                serveLoad(link, href);
            else
                loadPopup(href, false, link);
        }

        hash = getWindowHash();
    }

    function makeLinkWithParams(href, params) {
        var paramsCopy = $.extend({}, params);

        href = historyApi.removeAllQueryParametrs(href);

        if(paramsCopy['action']) {
            href = historyApi.addQueryParametrToUrl(href, 'action', paramsCopy['action']);
            delete paramsCopy['action'];
        }

        var link = $('<a href="' + href + '"></a>');

        for(var parametr in paramsCopy) {
            link.attr('data-enquiry-' + parametr, paramsCopy[parametr]);
        }

        return link;
    }

    function removeHistory() {
        if (getWindowHashDecoded().length) {
            hash = '';
            window.location.hash = '';

            var back = getHistoryArray();

            //need to removem all prev close
            for (var i = 0, l = back.length; i < l ; i++) {
                if (back[i] === 100)
                    back[i] = 0;
            }

            back.push(100);
            setHistoryArray(back);
        }
    }

    function initialHistory() {
        if (getWindowHashDecoded().length) {
            return;
        }
        var back = getHistoryArray();
        back.push(0);
        setHistoryArray(back);
    }

    function addToHistory(link) {
        var back = getHistoryArray(),
            linkhash = link.attr('href'),
            href = getWindowHashDecoded(),
            step = popupContent.find('.js-popup-current').attr('data-enquiry-step'),
            settings = getAllDataEnquiry(link);

        // if it is a Mobile Journey process type, then abort changing hash, bug SR-650
        var isMobileJourneyProcess = (this.url.search(/\/enquiry-process/i) !== -1);
        if (isMobileJourneyProcess) {
            linkhash = linkhash.replace('change-step', 'update-step');
        }
        else {
            linkhash = linkhash.replace('update-step', 'change-step');
        }

        for(var param in settings) {
            settings[param] = settings[param] || historyApi.getQueryParametr(href, param);
        }

        if (currentCustomClass) {
            settings['customclass'] = currentCustomClass;
        }

        if (step && !isMobileJourneyProcess) {
            var stepInt = parseInt(step),
                hashStep = historyApi.getQueryParametr(decodeURIComponent(hash), 'step');
            //if go straight to the 2nd or 3rd step on opening
            if (historyApi.isSessionAndHistory && hashStep == '') {
                for (var i = 1; i < stepInt; i++) {
                    settings['step'] = i;
                    historyApi.addToHistory("#" + encodeURIComponent("#" + historyApi.addAllQueryParametrsToUrl(linkhash, settings)));
                    back.push(i);
                }
            }
            back.push(stepInt);
            settings['step'] = step;
        }

        linkhash = historyApi.addAllQueryParametrsToUrl(linkhash, settings);
        linkhash = '#' + linkhash;
        linkhash = encodeURIComponent(linkhash);

        if ('#' + linkhash != window.location.hash) {
            setHistoryArray(back);
            hash = linkhash;
            window.location.hash = linkhash;
        }
    }

    function sendGAEvents(selector) {
        if (typeof selector === "undefined") {
            return;
        }

        var $dataContainer = $(selector);
        if ($dataContainer.length) {
            var eventData = $dataContainer.attr('data-gaevent'),
                pageViewData = $dataContainer.attr('data-gapageview');

            if (eventData) {
                dataLayer.push({ 'event': eventData });
            }

            if (pageViewData) {
                gaTracking.safeGa('send', 'pageview', pageViewData);
            }
        }
    }

    function open() {
        var load = require('async-image-loader');

        if (isOpened) {
            return;
        }

        if(currentCustomClass) {
            popupContainer.removeClass(currentCustomClass);
            currentCustomClass = '';
        }

        if(customClass) {
            currentCustomClass = customClass;
            popupContainer.addClass(currentCustomClass);
        }

        hideResumeQuoteBar();

        $('.js-content .js-sf-carousel').trigger('carousel:pause');
        $(window).trigger('close:simplepopup');

        isOpened = true;
        isAnimating = true;

        $('html').addClass(className);

        tweenPromote(tween);
        tween = new TimelineMax({ onStart: openAnimationStart, onComplete: openAnimationEnd });

        var maxWidth = main.outerWidth();
        popupInner.css('min-height', window.App.globals.height);
        main.css('max-width', maxWidth);
        popupContainer.css('max-width', maxWidth);

        var top = Math.max(document.documentElement.scrollTop, document.body.scrollTop),
            popupHeight = popupInner.outerHeight(),
            topOffsetTop = topParts.last().offset().top,
            topOffsetHeight = topParts.last().outerHeight(),
            topHeight = topOffsetTop + topOffsetHeight,
            toTop = Math.max(topOffsetHeight, topHeight - top);

        scrollToTop = top;
        dimensions.width = window.App.globals.width;
        dimensions.height = window.App.globals.height;

        if (window.App.globals.isTabletSmall) {
            tween.to(popupContainer, 0.0, { opacity: 0 });
            tween.to(popupContainer, 0.0, { maxHeight: 'none' });
            tween.to(popupContainer, 0.5, { opacity: "1" });
            tween.to(window, 0.0, { scrollTo: { y: 0 } });
            tween.to(main, 0.0, { position: "absolute", maxHeight: "0", opacity: 0 }, "+=0.5");
            tween.to(popupContainer, 0.0, { position: "relative" });
        } else {
            tween.to(popupContainer, 0.0, { opacity: 1 });
            if (top > topOffsetTop) {
                tween.to(window, 0.5, { scrollTo: { y: topOffsetTop } });
            }
            if (toTop) {
                tween.to(main, 0.4, { y: -toTop },  top > topHeight ? "+=0.2" : "+=0.0" );
            }
            tween.to(bottomParts, 0.5, { y: popupHeight });
            tween.fromTo(popupContainer, 0.5, { maxHeight: "0" }, { maxHeight: popupHeight }, "-=0.5");
            tween.to(window, 0.0, { scrollTo: { y: 0 } });
            tween.to(main, 0.0, { position: "absolute", maxHeight: "0", opacity: 0 }, "+=0.5");
            tween.to(popupContainer, 0.0, { position: "relative" }, "+=0.2");
        }

        tween.play();

        // loading large animated gif image
        //"var" for fix uglify plugin, need update webpack
        var preloadedImg = '/App_Themes/Safestore/img/loaders/safestore-loader.gif';

        switch(true) {

            case $('body').hasClass('bel-site'):
                preloadedImg = '/App_Themes/Safestore/img/loaders/safestore-loader__my.gif';
                break;

            case $('body').hasClass('upp-site'):
                preloadedImg = '/App_Themes/Safestore/img/loaders/safestore-loader__upp.gif';
                break;

            case $('body').hasClass('m3-site'):
                preloadedImg = '/App_Themes/Safestore/img/loaders/safestore-loader__mijn.gif';
                break;

            case $('body').hasClass('es-site'):
                preloadedImg = '/App_Themes/Safestore/img/loaders/safestore-loader__omb.gif';
                break;
        }


        load([ preloadedImg ], function(images){
            images.forEach(function (img) {
                img.classList.add('visually-hidden');
                document.body.appendChild(img);
            });
        });
    }

    // SR-686 fix
    function openAnimationStart() {
        $(window).trigger('map:updateVisibility', { shouldShowMap: false });
    }

    function openAnimationEnd() {
        isAnimating = false;
        popupContainer.css('max-height', 'none');
        popupLoaded();
    }

    function close(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        if(!isOpened)
            return;

        isOpened = false;
        isAnimating = true;
        removeHistory();

        showResumeQuoteBar();

        var top = scrollToTop,
            topHeight = 0;

        for (var i = 0, l = topParts.length; i < l; i++) {
            topHeight += topParts.eq(i).outerHeight();
        }

        var toTop = Math.max(0, topHeight - top),
            fromBottom = window.App.globals.height + toTop;

        tweenPromote(tween);
        tween = new TimelineMax({ onComplete: closeAnimationEnd });

        if (window.App.globals.isTabletSmall) {
            tween.to(bottomParts, 0.0, { y: 0 });
            tween.to(main, 0.0, { y: 0, opacity: 0, maxHeight: "none" });
            tween.to(popupContainer, 0.5, { opacity: 0 });
            tween.to(popupContainer, 0.0, { position: "fixed", maxHeight: 0 });
            tween.to(main, 0.0, { position: "relative" });
            tween.to(window, 0.0, { scrollTo: { y: scrollToTop } }, "+=0.1");
            tween.to(main, 0.5, { opacity: 1 });
        } else {
            tween.to(popupContainer, 0.3, { opacity: 0 });
            tween.to(popupContainer, 0.0, { position: "fixed", maxHeight: 0 });
            tween.to(main, 0.0, { position: "relative", maxHeight: "none" });
            tween.to(main, 0.0, { y: -toTop });
            tween.to(bottomParts, 0.0, { y: fromBottom });
            tween.to(window, 0.0, { scrollTo: { y: scrollToTop } });
            tween.to(main, 0.0, { opacity: "1" });
            tween.to(main, 0.3, { y: 0 }, "+=0.05");
            tween.to(bottomParts, 0.3, { y: 0 }, "-=0.3");
        }

        tween.play();
    }


    function closeAnimationEnd() {
        isAnimating = false;
        $(window).trigger('fixed:update');
        $('html').removeClass(className);
        main.removeAttr('style');
        bottomParts.removeAttr('style');
        popupContainer.removeAttr('style');
        popupCloseDialog.removeAttr('style');
        isCloseDialogOpened = false;
        $('.js-popup-btn').removeClass('active');
        $('.js-content .js-sf-carousel').trigger('carousel:play');

        // SR-686 fix
        $(window).trigger('map:updateVisibility', { shouldShowMap: true });
    }

    function openCloseDialog() {
        isCloseDialogOpened = true;

        tweenPromote(tweenClosingDialog);
        tweenClosingDialog = new TimelineMax();
        popupContainer.css('max-height', Math.max(window.App.globals.height, popupCloseDialogInner.outerHeight(true)));
        tweenClosingDialog.to(popupCloseDialog, 0.0, {visibility: "visible"});
        tweenClosingDialog.to(popupCloseDialog, 0.5, { opacity: 1 });
        tweenClosingDialog.play();
    }

    function closeCloseDialog(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        isCloseDialogOpened = false;
        tweenPromote(tweenClosingDialog);
        tweenClosingDialog = new TimelineMax();
        tweenClosingDialog.to(popupCloseDialog, 0.5, { opacity: 0 });
        tweenClosingDialog.to(popupContainer, 0.0, { maxHeight: "none" });
        tweenClosingDialog.to(popupCloseDialog, 0.0, { visibility: "hidden" });
        tweenClosingDialog.play();
        updateTrackingData();
        sendTrackingData('Continue my quote');
    }

    function onClose(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        if(isCloseDialogOpened || !isCloseDialogFilled) {
            updateTrackingData();
            sendTrackingData($(e.target).data('tracking-button-text'));
            close();

        } else {
            openCloseDialog();
        }
    }

    function popupCloseDialogClick(e) {
        var target = $(e.target);
        if (isCloseDialogOpened && !target.hasClass('.js-popup-close-dialog-inner') && !target.parents('.js-popup-close-dialog-inner').length) {
            closeCloseDialog();

        }
    }

    function updateContent(toAppend, content, updateHrefFunction, toContainer) {
        if (tweenLoading != null && typeof tweenLoading.progress == 'function' && tweenLoading.progress() < 1) {
            tweenLoadingCallback.push(arguments.callee.bind(this, toAppend, content, updateHrefFunction, toContainer));
            return;
        }

        if (toAppend) {
            var to = typeof toContainer == 'undefined' ? popupContent : toContainer,
                children = to.children();
            to.append(content);
            children.remove();
        } else {
            popupContent.html(content);
        }

        var popupCloseMessage = popupContent.find('.js-popup-close-dialog');
        if (popupCloseMessage.length) {
            isCloseDialogFilled = true;
            popupCloseDialogInner.html(popupCloseMessage.html());
        } else {
            isCloseDialogFilled = false;
        }

        if (typeof updateHrefFunction == "function")
            updateHrefFunction();

        reinitLinks();
        afterContentLoad();
        loaded();
    }

    function load(scrollToTop) {
        popupContainer.addClass('loading');

        var timingLoad = isAnimating ? 0 : 0.5;

        tweenPromote(tweenLoading);
        tweenLoading = new TimelineMax({ onComplete: tweenLoadingComplete });
        if (!isAnimating && (typeof scrollToTop == 'undefined' || scrollToTop != false)) {
            tweenLoading.to(window, timingLoad, { scrollTo: { y: 0 } });
        }
        tweenLoading.to(popupLoader, 0.0, {visibility: "visible" });
        tweenLoading.to(popupLoader, timingLoad, { opacity: 1 });
        tweenLoading.play();

    }

    function loaded() {
        popupContainer.removeClass('loading');
        popupLoader.html('');

        if (tweenLoading != null && typeof tweenLoading.progress == 'function' && tweenLoading.progress() < 1) {
            tweenLoadingCallback.push(loaded);
            return;
        }

        var timingLoad = isAnimating ? 0 : 0.5;
        tweenLoading = new TimelineMax({ onComplete: tweenLoadingComplete });
        tweenLoading.to(popupLoader, timingLoad, { opacity: 0 });
        tweenLoading.to(popupLoader, 0.0, { visibility: "hidden" });
        tweenLoadingCallback.push(popupLoaded);
        tweenLoading.play();

        sendGAEvents('.js-step-info');
    }

    function popupLoaded() {
        $(document).trigger('popup:loaded');
        $(document).trigger('activity.logger:reinit');


        var LazyLoad = require("vanilla-lazyload");
        var lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            to_webp: true,
            skip_invisible:false
        });
    }

    function tweenLoadingComplete() {
        var callbackArray = tweenLoadingCallback.slice();
        tweenLoadingCallback = new Array();
        for (var i = 0, l = callbackArray.length; i < l; i++) {
            callbackArray[i]();
        }
    }

    function tweenPromote(tween) {
        if (typeof tween == 'undefined' || tween == null)
            return;

        if (typeof tween.progress == 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);

            if (!isOpened)
                closeAnimationEnd();
        }

        if (typeof tween.destroy == 'function') {
            tween.destroy();
        }
    }

    function clickProcess(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var link = $(e.target);
        if (!link.is('a')) {
            link = link.parents('a');
        }

        var href = link.attr('href');

        if (link[0].hasAttribute('data-origin')) {
            updateTrackingData(link);
        }

        if (link.hasClass('js-popup-btn-serve')) {
            serveLoad(link, href);
        } else {
            var cache = link.attr('data-cache'),
                tocache = !cache || cache == 'true';
            loadPopup(href, tocache, link, link.attr('data-to'));
        }
    }

    function getAllDataEnquiry(link) {

        var dataAttributes = link.data(),
            settings = {},
            starting = 'enquiry';

        for (var attr in dataAttributes) {
            if (attr.indexOf(starting) == 0) {
                settings[attr.substr(starting.length).toLowerCase()] = dataAttributes[attr];
            }
        }

        return settings;
    }

    function serveLoad(link, href) {
        var settings = getAllDataEnquiry(link);
        $.ajax({
            method: "POST",
            url: href,
            dataType: "json",
            data: settings,
            cache: false,
            success: function (data) {
                if (data.status == "ok") {
                    loadPopup(data.url, false, link);
                } else {
                    errorAlert(null, data.message || "");
                }
            },
            error: function (data) {
                errorAlert(null, data.message || "");
            }
        });

    }

    function errorAlert(e, message) {
        if (isOpened) {
            if (typeof message != 'undefined' && message.length) {
                alert(message);
            }
            close();
        }
    }

    function loadPopup(href, tocache, link, to) {
        customClass = link.attr('data-customclass') || link.attr('data-enquiry-customclass') ||  '';

        if (isEnquiryProcessPage(href)) {
            dataLayer.push({ 'dynx_pagetype': 'conversionintent' });
        }

        if (isOpened) {
            load();
        }
        //if link we need is already in a popup
        if (!isOpened && globHref === href && tocache) {
            open();
            addToHistory(link);
            return;
        }


        //return back the content from the page if taken
        if (globHref && globHref[0] == '#') {
            var elementReturn = $(globHref);
            if (elementReturn.length) {
                elementReturn.append(popupContent.children());
            }
        }

        //if link is local
        if (href[0] == '#') {
            var appendChildren = $(href),
                updateHistory = isOpened ? null : addToHistory.bind(this, link);
            appendChildren = appendChildren.length ? appendChildren.children().not('script') : $('<div></div>');
            if (to) {
                var toContainer = $(to);
                if (!toContainer)
                    return;
                updateContent(true, appendChildren, updateHistory, toContainer);
            } else {
                globHref = href;
                updateContent(true, appendChildren, updateHistory);
            }

        } else {
            if (!isOpened)
                load(false);

            //ajax call for remote link
            $.ajax({
                url: href,
                cache: tocache,
                success: function (data) {
                    globHref = href;
                    updateContent(false, $(data).find('.js-content').html(), addToHistory.bind(this, link));
                },
                error: function (data) {

                }
            });
        }


        open();


    }

    function hideResumeQuoteBar() {
        $(window).trigger('resumedropdown:hide');
        $(window).trigger('fixonscroll:allow');
    }

    function getIncompleteQuoteUrl() {
        var url = '/getincompletedquote.ashx';

        if (window.appState.enquiryProcess) {
            return window.appState.enquiryProcess.incompleteHandlerUrl || url;
        }

        return url;
    }

    function showResumeQuoteBar() {
        $.ajax({
            url: getIncompleteQuoteUrl(),
            cache: false,
            success: function (data) {
                if(typeof data == 'undefined' || data === null) {
                    $(window).trigger('resumedropdown:hide');
                    return;
                }

                var source = $("#incompleted-quote-template").html();
                var rendered = Handlebars.compile(source);
                $(".js-incompletedquote-template-container").html(rendered(data));
                reinitLinks();
                gaTracking.reInitLinksGatracking();
                $(window).trigger('resumedropdown:delayShow');
                $(window).trigger('fixonscroll:destroy');
            },
            error: function (data) {

            }
        });
    }

    function updateTrackingData(link) {
        var stepInfo =$('.js-step-info');
        if (typeof link != 'undefined') {
            trackingData.origin = link.attr('data-origin');
        }
        else trackingData.origin = $(stepInfo).data('tracking-category');

        if (stepInfo.length) {
            trackingData.storeName = stepInfo.attr('data-store-name');
        }
        trackingData.step = historyApi.getQueryParametr(decodeURIComponent(hash), 'step') || 1;
    }

    function sendTrackingData(act) {
        var label = trackingData.storeName + ' > Step ' + trackingData.step + ' > ' + act;
        $(document).trigger('gatrack:senddata', ['event', 'Quote', trackingData.origin, label]);
    }

    function afterContentLoad() {
        $(window).trigger('newlayout:init');
        $(window).trigger('tabs:init');
        $(window).trigger('video:init');
        $(window).trigger('carousels:init');
        $(window).trigger('forms:reinit');
        $(window).trigger('gatracking:init');
        $(window).trigger('fixonscroll:reinit');
        $(window).trigger('tabs:resize');
    }

    function beforeSubmit(e) {
        var defaultLoaderText = "One second, we're just fetching your quote...";
        var defaultNonSmText = "Submitting your office enquiry...";
        var loaderText = popupContainer.data('enquiryLoaderMessage') || defaultLoaderText ;

        if (('#' + hash) == window.location.hash) {

            //2 because first symbol is # and is indicates popup opening
            var href = getWindowHashDecoded().substr(1);
            if (href.indexOf('enquiryprocess') == -1) {
                return;
            }

            if (!href.length) {
                return;
            }

            var siteId = historyApi.getQueryParametr(href, 'siteid');
            if (siteId.startsWith('NONSM-CENTER')) {
                loaderText = popupContainer.data('enquiryNonSmLoaderMessage') || defaultNonSmText;
            }
        }

        popupContainer.addClass('popup-container--last-step');
        popupLoader.append("<div>" + loaderText + "</div>");
        load(window.App.globals.isMobileView); // scroll to the top for small screen
    }

    function noDetailsSubmit(e) {
        let nodetails = false;
        var steps = $('.store-steps__item span');        

        steps.each(function(index, step) {
            if ($(step).attr('data-enquiry-no-details')) {
                nodetails = true;
            }
        });

        if (nodetails) {
            var defaultLoaderText = "One second, we're just fetching your quote...";        
            var loaderText = popupContainer.data('enquiryLoaderMessage') || defaultLoaderText ;
            popupContainer.addClass('popup-container--last-step');
            popupLoader.append("<div>" + loaderText + "</div>");
            load(window.App.globals.isMobileView);        
        }
        
    }

    function isEnquiryProcessPage(href) {
        return href && (href.search(/\/enquiry-process/i) !== -1);
    }

    return {
        init: init,
        reinit: reinitLinks
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.popup.js
 ** module id = 19
 ** module chunks = 24
 **/